import { render, staticRenderFns } from "./EditLayout.vue?vue&type=template&id=65bf4f0b&scoped=true"
import script from "./EditLayout.vue?vue&type=script&lang=ts"
export * from "./EditLayout.vue?vue&type=script&lang=ts"
import style0 from "./EditLayout.vue?vue&type=style&index=0&id=65bf4f0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bf4f0b",
  null
  
)

export default component.exports